import CustomAccordion from "@/components/CommonComponent/Accordian";
import TermsAndConditionData from "../../data/data.json";
const TermsAndCondition = () => {
  const accordionData = TermsAndConditionData.termsPrivacyAccordion;

  return (
    <div className="font-roboto">
      <h3 className="text-3xl font-semibold w-full text-center md:pt-16 text-[#111111]">
        Terms and Conditions
      </h3>
      <section className="flex flex-col md:flex-row items-start md:items-center gap-5 lg:gap-4 md:pb-6 lg:pb-8 xl:pb-10 pt-14 px-6 sm:px-8 md:px-20 lg:px-32 xl:px-35 2xl:px-44 3xl:px-56 4xl:px-64">
        <h3 className="text-2xl w-40 shrink-0 font-medium font-poppins text-[#1111111]">
          Terms of Use
        </h3>
        <div className="w-full h-[1.5px] bg-slate-200"></div>
      </section>
      <section className="self-start text-start pb-16 md:pb-24">
        <CustomAccordion
          items={accordionData}
          className="px-6 sm:px-8 md:px-20 lg:px-32 xl:px-35 2xl:px-44 3xl:px-56 4xl:px-64 pt-12 md:pt-3 pb-12 md:pb-8"
        />
      </section>
    </div>
  );
};

export default TermsAndCondition;
